const runtimeEnv =
  typeof window !== "undefined" && window.__ENV__ ? window.__ENV__ : {};
const buildEnv = process.env;

const source = Object.keys(runtimeEnv).length > 0 ? runtimeEnv : buildEnv;

export default {
  CURRENT_ENV: source.VUE_APP_CURRENT_ENV,
  BASE_URL: source.VUE_APP_BASE_URL,
  CHAT_BASE_URL: source.VUE_APP_CHAT_BASE_URL,
  NLP_BASE_URL: source.VUE_APP_NLP_BASE_URL,
  LLM_BASE_URL: source.VUE_APP_LLM_BASE_URL,
  LLM_TOKEN: source.VUE_APP_LLM_TOKEN,
  RAG_BASE_URL: source.VUE_APP_RAG_BASE_URL,
  SESSION_MANAGER_BASE_URL: source.VUE_APP_SESSION_MANAGER_BASE_URL,
  WIDGET_IFRAME_URL: source.VUE_APP_WIDGET_IFRAME_URL,
  FACEBOOK_APP_ID: source.VUE_APP_FACEBOOK_APP_ID,
  UPLOADS_URL: source.VUE_APP_UPLOADS_URL,
  GATEWAY: source.VUE_APP_GATEWAY,
  TWITTER_SUBSCRIPTION_URL: source.VUE_APP_TWITTER_SUBSCRIPTION_URL,
  TWITTER_WEBHOOK_URL: source.VUE_APP_TWITTER_WEBHOOK_URL,
  TWITTER_ENV: source.VUE_APP_TWITTER_ENV,
  ANALYTICS_IFRAME_URL: source.VUE_APP_ANALYTICS_IFRAME_URL,
  LICENCE_MANAGER_BASE_URL: source.VUE_APP_LICENCE_MANAGER_BASE_URL,
  CUBE_BASE_URL: source.VUE_APP_CUBE_BASE_URL,
  VOICE_API: source.VUE_APP_VOICE_API,
  VUE_APP_DOCKER_BUILD: source.VUE_APP_DOCKER_BUILD,
};
